module.exports = __webpack_public_path__ + "img/138.0c987ce6.png";